/**
 * Generated by orval v7.21.0 🍺
 * Do not edit manually.
 * OpenAPI definition
 * OpenAPI spec version: v0
 */

export type TouchpointCreateRequestPopulationType =
  (typeof TouchpointCreateRequestPopulationType)[keyof typeof TouchpointCreateRequestPopulationType];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const TouchpointCreateRequestPopulationType = {
  PARENT: "PARENT",
  STUDENT: "STUDENT",
} as const;
